module.exports = __webpack_public_path__ + "static/header-right-banner-40cef0f23bc60db28aa5aa0bdd38a9df.jpeg";